// src/Root.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { UserProvider } from './context/UserContext';
import { UploadManagerProvider } from './context/UploadManagerContext';
import UploadTray from './components/upload/UploadTray';

// UploadManagerProvider sits ABOVE the router so an in-progress upload (and its
// floating tray) survives route changes and the upload modal closing.
const Root = () => (
    <UserProvider>
        <UploadManagerProvider>
            <Router>
                <AppRoutes />
            </Router>
            <UploadTray />
        </UploadManagerProvider>
    </UserProvider>
);

export default Root;
